<script>
import { Cropper } from 'vue-advanced-cropper'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  components: {
    Cropper,
  },
  mixins: [validationMixin],
  props: {
    itemName: {
      type: String,
      required: false,
      default: '',
    },
    itemImage: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      detailForm: {
        hubName: this.itemName,
        hubImg: this.itemImage,
      },
      toCropImage: false,
      visibleImageCropper: false,
      croppedImage: false,
    }
  },
  validations: {
    detailForm: {
      hubName: {
        required,
      },
    },
  },
  methods: {
    clickOnFileUpload() {
      this.$refs.file.click()
    },
    uploadFiles(event) {
      var input = event.target
      if (input.files && input.files.length > 0) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.toCropImage = {
            original: e.target.result,
            cropped: null,
          }
        }
        reader.readAsDataURL(input.files[0])
        this.visibleImageCropper = true
      }
    },
    onClose() {
      this.visibleImageCropper = false
    },
    crop() {
      const { coordinates, canvas } = this.$refs.cropper.getResult()
      this.coordinates = coordinates
      this.toCropImage.cropped = canvas.toDataURL()
    },
    finishCropping() {
      this.crop()
      this.croppedImage = this.toCropImage.cropped
      this.detailForm.hubImg = this.croppedImage
      this.visibleImageCropper = false
    },
    getFormData() {
      const vuelidate = this.$v.detailForm
      vuelidate.$touch()
      // if its still pending or an error is returned do not submit
      if (vuelidate.$pending || vuelidate.$error) {
        this.$emit('trigger-detail-tab')
        return {}
      }
      // to form submit after this
      const event = this.detailForm
      return { name: event.hubName, image_url: event.hubImg }
    },
  },
}
</script>

<template>
  <div>
    <div class="mb-10">
      <BaseInputText
        id="name"
        v-model="detailForm.hubName"
        :vuelidate="$v.detailForm.hubName"
        label="Hub Name: *"
        required
      />
    </div>
    <div>
      <label for="hubImg" class="block mb-3">Hub Image:</label>
      <div class="flex">
        <div class="relative">
          <div
            class="w-28 h-28 rounded-full border border-gray-dark overflow-hidden align-middle"
          >
            <img :src="detailForm.hubImg" class="w-full rounded-full" />
          </div>

          <div
            class="border border-blue-default rounded-full absolute bottom-0 right-0 p-2.5 bg-white w-10 h-10 cursor-pointer"
            @click="clickOnFileUpload"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19.494"
              height="16.611"
              viewBox="0 0 19.494 16.611"
            >
              <g
                id="Group_336"
                data-name="Group 336"
                transform="translate(-3 -2)"
              >
                <path
                  id="Path_180"
                  data-name="Path 180"
                  d="M19.774,18.611H5.72A2.72,2.72,0,0,1,3,15.891V8.347a2.72,2.72,0,0,1,2.72-2.72H7.08l.453-1.655A3.239,3.239,0,0,1,10.707,2h4.08a3.239,3.239,0,0,1,3.173,1.972l.453,1.655h1.36a2.72,2.72,0,0,1,2.72,2.72v7.544A2.72,2.72,0,0,1,19.774,18.611ZM5.72,6.534A1.813,1.813,0,0,0,3.907,8.347v7.544A1.813,1.813,0,0,0,5.72,17.7H19.774a1.813,1.813,0,0,0,1.813-1.813V8.347a1.813,1.813,0,0,0-1.813-1.813H18.06a.454.454,0,0,1-.453-.331l-.553-1.986a2.323,2.323,0,0,0-2.267-1.31h-4.08A2.323,2.323,0,0,0,8.44,4.217L7.892,6.2a.454.454,0,0,1-.453.331Z"
                />
                <path
                  id="Path_181"
                  data-name="Path 181"
                  d="M19.08,23.16a4.08,4.08,0,1,1,4.08-4.08,4.08,4.08,0,0,1-4.08,4.08Zm0-7.254a3.173,3.173,0,1,0,3.173,3.173A3.173,3.173,0,0,0,19.08,15.907Z"
                  transform="translate(-6.56 -7.106)"
                />
                <path
                  id="Path_182"
                  data-name="Path 182"
                  d="M35.36,16.72a1.36,1.36,0,1,1,1.36-1.36A1.36,1.36,0,0,1,35.36,16.72Zm0-1.813a.453.453,0,1,0,.453.453A.454.454,0,0,0,35.36,14.907Z"
                  transform="translate(-16.946 -6.56)"
                />
              </g>
            </svg>
          </div>
        </div>

        <div class="relative">
          <input
            ref="file"
            type="file"
            class="absolute bottom-0 w-20 opacity-0"
            multiple
            accept="image/*,video/*"
            @change="uploadFiles($event)"
          />
          <button
            class="button secondary-button h-7.5 leading-relax text-sml rounded-small-button px-3 mb-1 absolute bottom-0"
            @click="clickOnFileUpload"
          >
            Upload
          </button>
          <BaseModalWindow
            v-if="visibleImageCropper"
            modalcls="w-user-edit bg-white rounded-xl mx-auto px-11 shadow-box relative left-0 flex justify-between overflow-hidden"
            :visible="visibleImageCropper"
            @close="onClose"
          >
            <template v-slot:body>
              <div class="w-full mx-auto mt-12 mb-5">
                <div class="">
                  <Cropper
                    v-if="toCropImage"
                    ref="cropper"
                    :stencil-props="{
                      aspectRatio: 1 / 1,
                    }"
                    classname="w-full"
                    :src="toCropImage.original"
                  />
                </div>

                <div class="mt-3">
                  <button
                    class="button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3"
                    @click="finishCropping"
                  >
                    Done
                  </button>
                </div>
              </div>
            </template>
          </BaseModalWindow>
        </div>
      </div>
    </div>
  </div>
</template>
